import { Chip, styled } from '@mui/material';

type ChipProps = {
  hasLabel: boolean;
  isHavePermission: boolean;
  isSelected: boolean;
};
export const CustomMuiChip = styled(Chip, {
  shouldForwardProp: (prop: string) => !['hasLabel', 'isHavePermission', 'isSelected'].includes(prop),
})<Partial<ChipProps>>(({ theme, hasLabel, isHavePermission = true, isSelected }) => ({
  '&.MuiChip-root': {
    gap: hasLabel ? '6px' : '0',
    height: '24px',
    padding: '4px 8px',
    borderRadius: '4px',
    background: theme.palette.case.neutral.n100,
    margin: 0,
  },

  '& .MuiChip-label': {
    fontFamily: 'Archivo, sans-serif',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '16px',
    color: theme.palette.case.neutral.n800,
    padding: '0',
  },

  '& .MuiChip-icon': {
    height: '16px',
    width: '16px',
    margin: '0',
  },
  '&.info': {
    '&.MuiChip-root': {
      background: theme.palette.case.blue.b50,
    },
    '& .MuiChip-label': {
      color: theme.palette.case.blue.b700,
    },
  },

  '&.permission': {
    '&.MuiChip-root': {
      background: isHavePermission ? theme.palette.case.primary.p50 : 'transparent',
      padding: '6px 8px',
      height: '32px',
      border: isHavePermission ? 'none' : `1px solid ${theme.palette.case.primary.p100}`,
      svg: {
        path: {
          fill: isHavePermission ? theme.palette.case.aquamarine.a700 : theme.palette.case.neutral.n500,
        },
      },
    },
    '& .MuiChip-label': {
      color: isHavePermission ? theme.palette.case.aquamarine.a700 : theme.palette.case.neutral.n600,
    },

    '& .MuiChip-deleteIcon': {
      height: '16px',
      width: '16px',
      margin: '0',
      color: theme.palette.case.aquamarine.a700,
    },
  },

  '&.view': {
    '&.MuiChip-root': {
      gap: '8px',
      background: theme.palette.case.neutral.n100,
      padding: '8px 10px',
      height: '32px',
      borderRadius: '8px',
      minHeight: '36px',
    },
    '& .MuiChip-label': {
      color: theme.palette.case.neutral.n700,
      fontSize: '14px',
    },

    '& .MuiChip-deleteIcon': {
      height: '16px',
      width: '16px',
      margin: '0',
      color: theme.palette.case.neutral.n500,
    },

    [theme.breakpoints.down('sm')]: {
      '&.MuiChip-root': {
        wordBreak: 'break-all',
        height: 'auto',
      },

      '& .MuiChip-label': {
        display: 'block',
        whiteSpace: 'normal',
      },
    },
  },

  '&.edit': {
    '&.MuiChip-root': {
      gap: '8px',
      background: isSelected ? theme.palette.case.aquamarine.a50 : theme.palette.case.neutral.n0,
      padding: '8px 10px',
      height: '36px',
      borderRadius: '8px',
      border: `1px solid ${
        isSelected ? theme.palette.case.aquamarine.a600 : theme.palette.case.neutral.n200
      }`,
      '&:hover': {
        background: isSelected ? theme.palette.case.aquamarine.a50 : theme.palette.case.neutral.n100,
      },
    },
    '& .MuiChip-label': {
      color: theme.palette.case.neutral.n700,
      fontSize: '14px',
      fontWeight: 400,
    },

    '& .MuiChip-deleteIcon': {
      height: '16px',
      width: '16px',
      margin: '0',
      color: theme.palette.case.neutral.n500,
    },

    [theme.breakpoints.down('sm')]: {
      '&.MuiChip-root': {
        wordBreak: 'break-all',
        height: 'auto',
      },

      '& .MuiChip-label': {
        display: 'block',
        whiteSpace: 'normal',
      },
    },
  },
}));
